/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef, useCallback, useState } from 'react';

import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { useParams } from 'react-router-dom';

import * as Yup from 'yup';
import { FaSpinner } from 'react-icons/fa';
// Importamos FiCrop para o botão de "Cortar Imagem Atual"
import { FiCamera, FiCrop, FiDownload } from 'react-icons/fi';
import Resizer from 'react-image-file-resizer';
import Menu from '../../components/Menu';

import Input from '../../components/Input';
import Button from '../../components/Button';
import Select from '../../components/Select';

import Loading from '../../components/Loading';
import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import { Container, Content, ContentContainer, AvatarInputContainer } from './styles';
import getValidationErrors from '../../utils/getValidationErrors';
import ImageCropperModal from '../../components/ImageCropperModal';
import Avatar from '../../components/Avatar';

interface Transaction {
  id: string,
  user_id: string,
  name: string,
  birthDate: string,
  cpf: string,
  phone: string,
  rg: string,
  emissor: string,
  rg_uf: string,
  shipping_date: string,
  naturalness: string,
  naturalness_uf: string,
  address: string,
  email_data: string,
  profession: string,
  affiliation: string,
  education: string,
  specialization: string,
  email_profession: string,
  acting: string,
  visible: boolean,
  valid: number,
  avatar?: string;
}

const AlterarAssociado: React.FC = () => {
  const formRef = useRef<FormHandles>(null);

  const [associate, setAssociate] = useState<Transaction>();
  const { addToast } = useToast();
  const [isLoading, setIsLoading] = useState(false)
  const { id } = useParams<Record<string, string>>();

  const [imageToCrop, setImageToCrop] = useState<string | null>(null);
  const [showCropperModal, setShowCropperModal] = useState(false);


  const selectValidOptions = [
    { id: 1, value: 1, label: 'Aprovado' },
    { id: 2, value: 2, label: 'Recusado' },
  ]

  const handleSubmit = useCallback(
    async (data) => {
      // Lógica de handleSubmit (mantida)
      try {
        formRef.current?.setErrors({});
        const schema = Yup.object().shape({
          // ... validações
          city: Yup.string().required('Cidade é obrigatório'),
          state: Yup.string().required('Estado é obrigatório'),
          cep: Yup.string().required('CEP é obrigatório'),
          oab: Yup.string(),
          cpf: Yup.string().required('CPF obrigatório'),
          birthDate: Yup.string().required('Data de nascimento obrigatória'),
          name: Yup.string().required('Nome completo é obrigario'),
          rg: Yup.string().required('RG é obrigario'),
          rg_uf: Yup.string().required('UF RG é obrigario'),
          emissor: Yup.string().required('Orgão emissor é obrigario'),
          shipping_date: Yup.string().required('Data de expidissão é obrigario'),
          naturalness: Yup.string().required('Naturalidade é obrigario'),
          naturalness_uf: Yup.string().required('Estado de naturalidade é obrigario'),
          address: Yup.string().required('Endereço é obrigario'),
          email_data: Yup.string().required('E-mail obrigatório').email('Digite um e-mail válido'),
          email_profession: Yup.string().required('E-mail Profissional obrigatório').email('Digite um e-mail válido'),
          profession: Yup.string().required('Profissão é obrigario'),
          education: Yup.string().required('Escolaridade é obrigario'),
          specialization: Yup.string().required('Especialização é obrigario'),
          phone: Yup.string().required('Telefone é obrigario'),
          acting: Yup.string().required('Atuação é obrigario'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        await api.put(`/associates/${id}`, data);

        addToast({
          type: 'success',
          title: 'Associado Alterado',
          description: 'As informações do associado foram alteradas com sucesso',
        });

      } catch (err) {
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);
        }

        addToast({
          type: 'error',
          title: 'Erro Associado Alterado',
          description: 'Ocorreu um erro ao alterar as informações do associado',
        });
      }
    },
    [addToast, id],
  );


  useEffect(() => {
    async function loadAssociate(): Promise<void> {
      await api.get(`/associates/find/${id}`).then(response => {
        setAssociate(response.data);
        formRef?.current?.setData(response.data);
      });
    }

    loadAssociate();
  }, [id]);

  // Função para lidar com a seleção inicial de um NOVO arquivo (mantida)
  const handleFileChange = useCallback(async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];

      Resizer.imageFileResizer(
        file,
        1200,
        1200,
        'JPEG',
        90,
        0,
        (uri) => {
          setImageToCrop(uri as string);
          setShowCropperModal(true);
        },
        'base64'
      );
    }
    // Limpa o valor do input para permitir upload da mesma imagem novamente
    event.target.value = '';
  }, []);

  // Função para lidar com a imagem cortada pelo modal (mantida, com ajuste no update do estado)
  const handleCropComplete = useCallback(async (croppedImageFile: File) => {
    setIsLoading(true);
    let tempUrl: string | undefined;

    try {
      const data = new FormData();
      data.append('avatar', croppedImageFile);

      // Envia a imagem cortada (File) para o backend
      const response = await api.patch(`/associates/avatar/${id}`, data);

      // Assumindo que a resposta da API retorna a nova URL do avatar
      const newAvatarUrl = response.data.avatar_url || associate?.avatar;

      // Cria uma URL temporária para visualização imediata, se a API não retornar a URL
      if (!newAvatarUrl) {
        tempUrl = URL.createObjectURL(croppedImageFile);
      }

      // Atualiza o avatar no estado local
      setAssociate(oldAssociate => {
        if (!oldAssociate) return oldAssociate;
        return {
          ...oldAssociate,
          avatar: newAvatarUrl || tempUrl, // Prioriza a URL da API
        };
      });

      addToast({
        type: 'success',
        title: 'Alteração da foto',
        description: 'Foto do associado foi alterada com sucesso!',
      });
    } catch (e) {
      console.error(e);
      addToast({
        type: 'error',
        title: 'Erro na alteração da foto',
        description: 'Ocorreu um erro ao alterar a foto do associado.',
      });
    } finally {
      // Se usou uma URL temporária, revogue-a.
      if (tempUrl) {
        URL.revokeObjectURL(tempUrl);
      }
      setIsLoading(false);
      setShowCropperModal(false);
      setImageToCrop(null);
    }
  }, [addToast, id, associate?.avatar]);


  return (
    <Container>
      <Menu />
      <Content>
        <ContentContainer>

          <Form initialData={associate} ref={formRef} onSubmit={handleSubmit}>

            <h1>Cadastro de Associado</h1>

            <AvatarInputContainer>
              {associate?.avatar ? (
                <Avatar src={associate.avatar} alt={associate.name} />
              ) : (
                <div className="placeholder-avatar">
                  <span>Sem Imagem</span>
                </div>
              )}

              <div className="div-crop-existing-button">
                {/* Botão/Label para UPLOAD de um NOVO arquivo */}
                <label htmlFor="avatar" title="Fazer upload de nova foto">
                  <FiCamera />
                  <input
                    type="file"
                    id="avatar"
                    name="avatar"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </label>

                {/* Botão para CORTAR a imagem ATUAL do bucket */}
                {associate?.avatar && (
                  <a
                    title="Baixar Foto"
                    href={associate?.avatar}
                    target="_blank"
                    rel="noreferrer"
                    className="crop-existing-button"
                  >
                    <FiDownload />
                  </a>
                )}
              </div>

            </AvatarInputContainer>

            <h3>Dados Pessoais</h3>
            {/* ... seus campos de Input ... */}
            <Input name="name" label="Nome Completo" />

            <div className="div_agroup">
              <Input name="rg" label="RG" />
              <Input name="emissor" label="Órgão Emissor " />
              <Input name="rg_uf" label="UF" />
            </div>

            {/* ... o restante do seu formulário ... */}

            <div className="div_agroup">
              <Input name="shipping_date" label="Data de Expedição" />
              <Input name="affiliation" label="Filiação" />
            </div>

            <div className="div_agroup">
              <Input name="cpf" label="CPF" />
              <Input name="naturalness" label="Naturalidade" />
              <Input name="naturalness_uf" label="Naturalidade UF" />
            </div>

            <div className="div_agroup">
              <Input name="phone" label="Telefone" />
              <Input name="birthDate" label="Data Nascimento" />
            </div>

            <Input name="email_data" label="Email" />

            <div className="div_agroup">
              <Input name="city" label="Cidade" />
              <Input name="state" label="Estado" />
            </div>

            <div className="div_agroup">
              <Input name="address" label="Endereço (Rua, n°, Complemento)" />
              <Input name="cep" label="CEP" />
            </div>

            <h3>Dados Profissionais</h3>

            <Input name="oab" label="Registro de Associado" />

            <div className="div_agroup">
              <Input name="profession" label="Profissão" />
              <Input name="acting" label="Atuação" />
            </div>

            <div className="div_agroup">
              <Input name="education" label="Escolaridade" />
              <Input name="specialization" label="Especialização" />
            </div>

            <Input name="email_profession" label="Email Profissional" />

            <br />
            <label className="label_select">Status:</label>
            <Select name="valid">
              {selectValidOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>

            <Button type="submit" color="#2A2A29">Alterar</Button>
          </Form>
        </ContentContainer>

        {showCropperModal && imageToCrop && (
          <ImageCropperModal
            imageSrc={imageToCrop}
            onClose={() => {
              setShowCropperModal(false);
              setImageToCrop(null);
            }}
            onCropComplete={handleCropComplete}
          />
        )}

        {isLoading &&
          (
            <div style={{ position: 'absolute', width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.2)', top: 0, left: 0 }}>
              <Loading>
                <h1>
                  Carregando
                </h1>
                <FaSpinner size={25} />
              </Loading>
            </div>
          )}
      </Content>
    </Container>
  );
};

export default AlterarAssociado;
